import { render, staticRenderFns } from "./automated-tags.vue?vue&type=template&id=450a1b94"
import script from "./automated-tags.vue?vue&type=script&lang=js"
export * from "./automated-tags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports